import { useCallback, useState } from 'react';
import { normalizeSourcingMessage, resolveSourcingType } from 'features/ai-assistant/utils';
import { EntityType } from 'UI/constants/entityTypes';

export const useSourcingResults = () => {
  const [sessionType, setSessionType] = useState(null);
  const [activeResponseId, setActiveResponseId] = useState(null);

  const applySessionType = useCallback(rawType => {
    const resolved = resolveSourcingType(rawType);
    if (!resolved) return;
    setSessionType(prev => prev || resolved);
  }, []);

  const handleMetaDataClick = useCallback(({ id }) => {
    setActiveResponseId(id);
  }, []);

  const handleMessageReplied = useCallback(
    responseData => {
      const normalized = normalizeSourcingMessage(responseData);
      if (!normalized) return;

      applySessionType(responseData?.type);
      setActiveResponseId(normalized.id);
    },
    [applySessionType]
  );

  const handleMessagesLoaded = useCallback(
    messages => {
      const typedMessage = (messages || []).find(message => resolveSourcingType(message?.type));
      if (typedMessage) applySessionType(typedMessage.type);
    },
    [applySessionType]
  );

  const handleSessionSelected = useCallback(session => {
    setSessionType(resolveSourcingType(session?.type));
  }, []);

  const reset = useCallback(() => {
    setSessionType(null);
    setActiveResponseId(null);
  }, []);

  return {
    activeResponseId,
    entityType: sessionType ?? EntityType.Candidate,
    handleMessageReplied,
    handleMessagesLoaded,
    handleMetaDataClick,
    handleSessionSelected,
    reset
  };
};
